import React, { Component } from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import { UIStyleProps, UIStyledTooltip } from "./UIComponents";
import "./UIRefresh.scss";

export type UIRefreshProps = {
	refreshArgs?: any;
	onRefresh: (args: any | undefined) => Promise<any>;
	refreshTitle?: string;
	dataView?: DataView;
	disabled?: boolean;
} & UIStyleProps;

export default class UIRefresh extends Component<UIRefreshProps> {
	private filterModel; // save filter state and apply after refresh

	state = {
		refreshing: false,
	};

	// isGridLoaded(): boolean {
	// 	return !!this.props.dataView && !!this.props.dataView.grid() && !!this.props.dataView.grid().state.gridApi;
	// }

	// saveFilters() {
	// 	if (!this.isGridLoaded()) return;
	// 	const dataGrid: DataGrid = this.props.dataView.grid();
	// 	this.filterModel = dataGrid.state.gridApi.getFilterModel();
	// }

	// applyFilters() {
	// 	if (!this.isGridLoaded()) return;
	// 	const dataGrid: DataGrid = this.props.dataView.grid();
	// 	dataGrid.state.gridApi.setFilterModel(this.filterModel);
	// 	this.filterModel = null;
	// }

	onRefresh() {
		this.setState({ refreshing: true });
		// this.saveFilters();
		// if (this.props.dataView && this.props.dataView.dataCompRef && this.props.dataView.dataCompRef.onRefresh) {
		// 	this.props.dataView.dataCompRef.onRefresh();
		// }
		this.props.onRefresh(this.props.refreshArgs).finally(() => {
			this.setState({ refreshing: false });
			// this.applyFilters();
		});
	}

	render() {
		const title: string = this.props.refreshTitle || "Refresh Data";
		return (
			<UIStyledTooltip
				style={this.props.style}
				className={clsx("ui-refresh", this.state.refreshing && "refreshing", this.props.className)}
				title={this.props.disabled ? undefined : title}
			>
				<IconButton
					edge="start"
					// size="small"
					aria-label={title}
					onClick={() => this.onRefresh()}
					disabled={this.props.disabled}
				>
					<RefreshIcon color="primary" />
				</IconButton>
			</UIStyledTooltip>
		);
	}
}
